import type { CompetencyFrameworkState } from "../types";

// Blocked from a second document import until the admin finishes the imported set.
export const isCompetencyReimportBlocked = (framework: CompetencyFrameworkState | null): boolean =>
	!!framework?.fromImport && framework.status !== "saved";
